import { render, staticRenderFns } from "./VideosList.vue?vue&type=template&id=45187ece&scoped=true"
import script from "./VideosList.vue?vue&type=script&lang=js"
export * from "./VideosList.vue?vue&type=script&lang=js"
import style0 from "./VideosList.vue?vue&type=style&index=0&id=45187ece&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45187ece",
  null
  
)

export default component.exports